import { IconProps } from '../icon';

export function LogoEcobriqueIcon(props: IconProps) {
  return (
    <svg
      id="Groupe_5953"
      data-name="Groupe 5953"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="400.929"
      height="206.4"
      viewBox="0 0 400.929 206.4"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_393"
            data-name="Rectangle 393"
            width="400.929"
            height="206.4"
            fill="none"
          />
        </clipPath>
      </defs>
      <g
        id="Groupe_5952"
        data-name="Groupe 5952"
        transform="translate(0 0)"
        clipPath="url(#clipPath)"
      >
        <path
          id="Tracé_616"
          data-name="Tracé 616"
          d="M122.355,95.139c-3.488-10.235-2.282-19.724,1.479-28.868,4.02-9.776,12.5-14.14,22.337-17.169-2.211-1-4.421-2.01-7.436-3.373,4.594-4.35,8.714-8.254,12.848-12.173l-.56-1.091a29.535,29.535,0,0,0-5.154,2.082c-17.255,10.982-27.806,26.686-32.357,46.511-.876,3.8-1.436,7.68-2.254,12.159-12.058,1.378-24.246,3.962-35.73,10.321-4.364-9.7-12.848-17.054-12.518-28.395-7.809-4.565-15.834-3.819-23.471-3.086-1.823,2.871-3.373,5.34-5.1,8.068-13.25-7.379-17.93-19.207-21.2-31.955,2.383-6.4,7.479-10.35,12.274-14.3,10.766-8.886,23.012-15.489,35.63-21.418,8.039-3.775,16.293-3.029,24.533-1.364,9.116,1.852,17.729.115,25.954-3.431a89.276,89.276,0,0,1,31.9-7.594c17.241-.675,33.2,4.048,46.683,15.36C204.9,27.769,214.788,43.1,218.736,62.05a32.476,32.476,0,0,0,2.053,5.2C214.243,79.491,207.41,91.277,195.9,99.589c-11.1,8.039-23.227,9.187-35.86,5.182-12.216-3.876-24.289-8.139-37.683-9.632M47.564,38.694c6.919-2.455,13.236-4.709,19.523-6.934-3.259-4.321-8.312-6.532-12.331-5.369-4.924,1.436-6.847,4.493-7.192,12.3"
          transform="translate(176.824 0.008)"
          fill="#64a440"
        />
        <path
          id="Tracé_617"
          data-name="Tracé 617"
          d="M182.99,5.4c3.761,9.661,2,19.322.258,28.725-3.9,21.145-11.757,40.783-25.294,57.708-16.336,20.442-36.448,35.415-62.69,40.6-20.011,3.962-39.075,1.665-56.4-9.948C10.8,103.68,6.592,61.562,38.447,39.44,51.711,30.21,66.6,27.726,82.575,29.377a137.724,137.724,0,0,1,34.151,8.369c25.854,9.618,47.416.416,61.039-22.538,1.866-3.144,3.445-6.46,5.225-9.8M53.132,115.653c3.086-2.01,5.642-3.661,7.982-5.182,2.885,1.694,5.34,3.115,7.737,4.522,5.814-4.465-.876-6.589-1.464-9.661,3.589-3.244,7.048-6.374,10.766-9.733,4.694,3.661,9,7.005,13.393,10.422-2.627,2.1-5.039,4.005-7.967,6.331.847,2.153,1.622,4.149,2.713,6.891,4.752-3.129,8.642-5.7,12.633-8.34a52.022,52.022,0,0,0,4.752,2.756,47.148,47.148,0,0,0,5.039,1.651c2.283-4.953-.3-7.881-3.058-10.924,3.761-3.6,7.537-7.206,11.456-10.939,4.407.833,8.111,5.3,13.451,4.235,1.464-5.383,1.335-6.13-2.1-7.766-2.268-1.077-5.01-1.349-6.417-3.7,1.392-4.307,5.843-6.862,5.857-12.776-5.484,2.828-7.091,8.154-11.484,11.025-6.532-3.23-13.494-6.058-19.437-11.3,1.823-2.383,3.56-4.35,4.924-6.575.445-.732-.057-2.067-.187-4.22-3.646,3.33-6.417,5.871-9.029,8.254-4.134-1.866-6.388-6.115-12.747-6.144,4.019,4.12,6.977,7.163,10.178,10.436-4.421,4.019-8.47,7.723-12.791,11.656-4.608-3.9-8.915-7.537-13.178-11.14C68.334,70,72.5,65.682,74.981,59.581c-5.168-.976-5.57,3.618-7.881,5.426a75.546,75.546,0,0,0-6.819,6.69c-4.206-1.924-5.67-6.79-12-7.336,3.244,4.378,5.6,7.537,8.082,10.9-4.608,3.8-8.283,7.881-13.307,9.661C40,83.5,39.064,79.836,34.413,78.932c2.082,3.775,3.5,6.374,4.881,8.872-2.053,1.938-3.89,3.675-6.187,5.843,1.608,1.766,2.885,3.173,4.106,4.522,2.857-1.493,5.111-2.67,7.493-3.919,3.273,3.6,6.245,6.862,9.2,10.092-2.771,3.4-4.522,6.675-.775,11.312"
          transform="translate(215.714 72.172)"
          fill="#ffa609"
        />
        <path
          id="Tracé_618"
          data-name="Tracé 618"
          d="M20.8,23.186c3.531-4.335,6.819-8.355,10.408-12.748,5.771,4.034,11.456,8.025,17.729,12.417-2.024,1.967-3.747,3.775-5.613,5.4-1.967,1.708-4.091,3.244-6.79,5.369-5.01-3.316-10.149-6.733-15.733-10.436"
          transform="translate(277.763 139.402)"
          fill="#ffa609"
        />
        <path
          id="Tracé_619"
          data-name="Tracé 619"
          d="M18.4,22.415c4.465-4.177,8.441-7.91,12.661-11.857,3.847,3.661,7.58,7.192,11.757,11.154-4.407,3.5-8.584,6.833-13.25,10.537-3.876-3.417-7.522-6.618-11.168-9.833"
          transform="translate(245.737 141.005)"
          fill="#ffa609"
        />
        <path
          id="Tracé_620"
          data-name="Tracé 620"
          d="M13.519,37.627H31.994V49.857H13.519V74.936H36.76V87.167H.068V1.538H36.76V13.768H13.519Z"
          transform="translate(0.907 20.534)"
          fill="#64a440"
        />
        <path
          id="Tracé_621"
          data-name="Tracé 621"
          d="M43.25,56.149V67.519c0,13.824-6.847,21.533-20.054,21.533S3.127,81.343,3.127,67.519V23C3.127,9.179,9.974,1.47,23.2,1.47S43.25,9.179,43.25,23v8.312H30.531V22.142c0-6.23-2.7-8.441-6.977-8.441s-6.977,2.211-6.977,8.441V68.38c0,6.245,2.7,8.326,6.977,8.326s6.977-2.082,6.977-8.326V56.149Z"
          transform="translate(41.762 19.632)"
          fill="#64a440"
        />
        <path
          id="Tracé_622"
          data-name="Tracé 622"
          d="M6.416,23C6.416,9.179,13.622,1.47,26.844,1.47S47.271,9.179,47.271,23V67.519c0,13.824-7.221,21.533-20.428,21.533S6.416,81.343,6.416,67.519ZM19.867,68.38c0,6.245,2.684,8.441,6.977,8.441s6.962-2.2,6.962-8.441V22.142c0-6.245-2.684-8.441-6.962-8.441s-6.977,2.2-6.977,8.441Z"
          transform="translate(85.688 19.632)"
          fill="#64a440"
        />
        <path
          id="Tracé_623"
          data-name="Tracé 623"
          d="M16.293,8.878c11.283,0,15.992,5.2,15.992,15.791v2.455c0,7.063-2.168,11.57-6.977,13.839,5.886,2.254,8.053,7.35,8.053,14.714V61.26c0,10.594-5.5,16.293-16.379,16.293H0V8.878Zm-5.5,9.8V36.842h4.22c4.019,0,6.474-1.766,6.474-7.264V25.745c0-5-1.665-7.063-5.5-7.063Zm0,27.964V67.735h6.187c3.618,0,5.584-1.665,5.584-6.761V54.987c0-6.374-1.967-8.34-6.962-8.34Z"
          transform="translate(0 118.568)"
          fill="#ffa609"
        />
        <path
          id="Tracé_624"
          data-name="Tracé 624"
          d="M25.341,77.54c-.1-.488-.287-.876-.388-1.278a10.33,10.33,0,0,1-.5-3.732c-.086-.876-.086-2.053-.086-3.431V58.319c0-6.388-2.067-8.728-7.063-8.728H13.569V77.54H2.774V8.879H19.067c11.283,0,15.992,5.2,15.992,15.791v5.4c0,7.063-2.354,11.671-7.063,13.925,5.484,2.254,7.149,7.45,7.149,14.614V69.2c0,3.431.1,5.7,1.177,8.34ZM13.569,18.684V39.772h4.22c4.019,0,6.474-1.766,6.474-7.249V25.746c0-5.01-1.665-7.063-5.5-7.063Z"
          transform="translate(37.048 118.582)"
          fill="#ffa609"
        />
        <rect
          id="Rectangle_392"
          data-name="Rectangle 392"
          width="10.795"
          height="68.661"
          transform="translate(79.27 127.446)"
          fill="#ffa609"
        />
        <path
          id="Tracé_625"
          data-name="Tracé 625"
          d="M6.758,26.092c0-11.082,5.8-17.269,16.394-17.269S39.531,15.01,39.531,26.092v35.7a20.165,20.165,0,0,1-2.067,9.618c.488,1.278,1.177,1.464,3.043,1.464h.976v9.618H40.019c-4.809,0-7.852-1.665-9.317-4.709a22.485,22.485,0,0,1-7.551,1.278c-10.594,0-16.394-6.187-16.394-17.269Zm10.8,36.391c0,5.01,2.153,6.776,5.6,6.776s5.584-1.766,5.584-6.776V25.4c0-5.01-2.153-6.776-5.584-6.776s-5.6,1.766-5.6,6.776Z"
          transform="translate(90.255 117.834)"
          fill="#ffa609"
        />
        <path
          id="Tracé_626"
          data-name="Tracé 626"
          d="M20.287,8.878V61.849c0,5.01,2.153,6.675,5.584,6.675s5.6-1.665,5.6-6.675V8.878H41.677V61.16c0,11.082-5.5,17.269-16.092,17.269S9.492,72.242,9.492,61.16V8.878Z"
          transform="translate(126.768 118.568)"
          fill="#ffa609"
        />
        <path
          id="Tracé_627"
          data-name="Tracé 627"
          d="M23.041,37.818H37.856v9.8H23.041V67.735H41.674v9.819H12.246V8.878H41.674V18.7H23.041Z"
          transform="translate(163.548 118.568)"
          fill="#ffa609"
        />
      </g>
    </svg>
  );
}

export default LogoEcobriqueIcon;
